/** Customer-facing assistant routes are opt-in to explicit pilot builds. */
export function isAssistantPilotEnvironment(environment: string): boolean {
  return environment === 'assistant-native-pilot' || environment === 'assistant-public-pilot';
}
